/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_TypeInputs */

const vi_shop_home_link_type = /** @type {(inputs: Shop_Home_Link_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loại đích`)
};

/**

* @param {Shop_Home_Link_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_type = /** @type {((inputs?: Shop_Home_Link_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_type(inputs)
});